/**
 * Get the hostname for the current environment.
 * This is used for API requests and other environment-specific URLs.
 */
export const getHostname = () => {
  // Use window.location.origin in browser context (client-side)
  // This is safer / more accurate than relying on process.env.NEXT_PUBLIC_VERCEL_URL
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  if (
    process.env.NODE_ENV === "development" ||
    (process.env.VERCEL_ENV !== "production" &&
      process.env.VERCEL_ENV !== "preview")
  ) {
    return `http://localhost:${process.env.PORT || 3000}`;
  }

  // For use in e2e tests locally
  if (
    process.env.VERCEL_ENV !== "production" &&
    process.env.VERCEL_ENV !== "preview"
  ) {
    return `http://localhost:${process.env.PORT || 3000}`;
  }

  if (process.env.NEXT_PUBLIC_IS_MOBILE_TEST === "1") {
    // This is a special flag env variable that is only set in the 'mstaging' environment.
    // This allows us to always use the same static subdomain for mobile testing, where
    // the domains need to be allowlisted at build time, such as universal links.
    return "https://mobiletest.punchup.live";
  }

  if (process.env.VERCEL_ENV === "preview") {
    return `https://${process.env.VERCEL_URL}`;
  }

  const protocol = process.env.NEXT_PUBLIC_PROTOCOL as string;
  const domain = process.env.NEXT_PUBLIC_VERCEL_URL as string;

  return `${protocol}://${domain}`;
};

export function getWebAppHostname() {
  if (
    process.env.NODE_ENV === "development" ||
    (process.env.VERCEL_ENV !== "production" &&
      process.env.VERCEL_ENV !== "preview")
  ) {
    return "http://localhost:3000";
  }

  if (process.env.VERCEL_ENV === "preview") {
    if (process.env.NEXT_PUBLIC_IS_EXTERNAL_SITE) {
      // TODO: we don't know what the preview punchup-web domain is, so use production. Will revisit.
      return "https://punchup.live";
    } else {
      return `https://${process.env.VERCEL_URL}`;
    }
  }

  return "https://punchup.live";
}
